/**
 * NSM SponsorsStrip — data from config/sponsors.js only. No dependency on old BrandOne/BrandNSM.
 * Uses same brand-one section class for existing CSS.
 */
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode } from "swiper/modules";
import "swiper/css";
import "swiper/css/free-mode";
import { sponsors } from "../../config/sponsors";

// Double the list for seamless loop
const SLIDES = sponsors.length > 0 ? [...sponsors, ...sponsors] : [];

export default function SponsorsStrip() {
  if (SLIDES.length === 0) return null;

  return (
    <section className="brand-one brand-one--nsm-strip">
      <div className="container">
        <Swiper
          modules={[Autoplay, FreeMode]}
          className="brand-marquee"
          loop
          loopAdditionalSlides={20}
          slidesPerView="auto"
          spaceBetween={48}
          freeMode={{ enabled: true, momentum: false }}
          allowTouchMove={true}
          centeredSlides={false}
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          speed={3500}
          breakpoints={{
            0:    { spaceBetween: 24, speed: 2800 },
            480:  { spaceBetween: 32, speed: 3200 },
            768:  { spaceBetween: 40, speed: 3500 },
            1200: { spaceBetween: 48, speed: 4000 },
          }}
        >
          {SLIDES.map((item, i) => (
            <SwiperSlide key={i} style={{ width: "auto" }}>
              <div className="brand-one__single">
                <div className="brand-one__img">
                  {item.url ? (
                    <a href={item.url} target="_blank" rel="noopener noreferrer" aria-label={item.alt}>
                      <img src={item.image} alt={item.alt} />
                    </a>
                  ) : (
                    <img src={item.image} alt={item.alt} />
                  )}
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}
